export enum Right {
	Create,
	Read,
	Update,
	Delete,
	AssignOwn,
	AssignAny
}
